export default {
	data() {
		return {
			dateDefaultValue: null
		};
	},
	props: {
		// Custom date format
		dateFormat: {
			type: String,
			default: 'YYYY-MM-DD'
		},
		// Custom time format
		timeFormat: {
			type: String,
			default: 'HH:mm:ss'
		}
	},
	computed: {
		dateValue() {
			if (typeof this.value !== 'object') {
				return this.$moment(this.value, this.attrs.dateFormat);
			}

			return this.value;
		},
		timeValue() {
			if (typeof this.value !== 'object') {
				return this.$moment(this.value, this.attrs.timeFormat);
			}

			return this.value;
		}
	},
	methods: {
		// DATE METHODS
		dateChange(date) {
			this.$emit('input', this.parseValue(date));
		},
		datePreparseValue(value) {
			if (value === '') value = null;

			if (typeof value !== 'object') return this.$moment(value).format(this.attrs.dateFormat);
			return value.format(this.attrs.dateFormat);
		},
		dateParseValue(value) {
			let isValid;

			if (typeof value === 'object') {
				isValid = value._isValid;
				if (isValid) return value.format(this.attrs.dateFormat);
			} else {
				value = this.$moment(value);
				isValid = value._isValid;
				if (isValid) return value.format(this.attrs.dateFormat);
			}

			return this.parseDefaultValue();
		},
		dateParseDefaultValue() {
			let defaultValue = this.dateDefaultValue;

			const aDate = this.$moment(this.defaultValue, this.attrs.dateFormat, true);
			const isValid = aDate._isValid;

			if (isValid) defaultValue = this.$moment(this.defaultValue).format(this.attrs.dateFormat);

			return defaultValue;
		},
		// TIME METHODS
		timeParseValue(value) {
			let isValid;

			if (typeof value === 'object') {
				isValid = value._isValid;
				if (isValid) return value.format(this.attrs.timeFormat);
			} else {
				value = this.$moment.utc(value, this.attrs.timeFormat);
				isValid = value._isValid;

				if (isValid) return value.format(this.attrs.timeFormat);
			}

			return this.parseDefaultValue();
		}
	}
};
